import { render, staticRenderFns } from "./Notauthorized.vue?vue&type=template&id=bfc5c3b2&scoped=true&"
import script from "./Notauthorized.vue?vue&type=script&lang=js&"
export * from "./Notauthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc5c3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc5c3b2')) {
      api.createRecord('bfc5c3b2', component.options)
    } else {
      api.reload('bfc5c3b2', component.options)
    }
    module.hot.accept("./Notauthorized.vue?vue&type=template&id=bfc5c3b2&scoped=true&", function () {
      api.rerender('bfc5c3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notauthorized-page/Notauthorized.vue"
export default component.exports